import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
} from '@angular/material/dialog';
import { RosteringUser } from '../teacher-users.model';
import { RestoreDeletedType } from '@app/teacher-users/restore-deleted-dialog/restore-deleted-dialog.component';
import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { BtnComponent } from '@wam/components';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'restore-deleted-confirm-dialog',
  templateUrl: './restore-deleted-confirm-dialog.component.html',
  styleUrls: ['./restore-deleted-confirm-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    MatDialogActions,
    BtnComponent,
    MatDialogClose,
    TranslatePipe,
  ],
})
export class RestoreDeletedConfirmDialogComponent {
  data = inject<{
    users: RosteringUser[];
    restoreType: RestoreDeletedType;
  }>(MAT_DIALOG_DATA);

  getDialogTitle() {
    return this.data.restoreType === RestoreDeletedType.RESTORE_STAFF
      ? marker('Restore Deleted Staff')
      : marker('Restore Deleted Students');
  }

  getRestoreContentTitle() {
    return this.data.restoreType === RestoreDeletedType.RESTORE_STAFF
      ? marker("You're restoring the following staff:")
      : marker("You're restoring the following students:");
  }
}
